import React, { Component } from "react";
import {
  Badge,
  Col,
  ListGroupItem,
  Row,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Tooltip
} from "reactstrap";
import CreatableSelect from "react-select/lib/Creatable";
import "../../../views/AlertMessage/AlertMessage";
import { BadgeWithAuth } from "../../../authComponents/authComponents";
import Entities from "./Entities";
import "./ConversationDetails.scss";
import {validate} from '../../../utils/validation'

const moment = require("moment-timezone");
const apiCalls = require("../../../ApiCalls");
const _ = require("lodash");
const stringSimilarity = require("string-similarity");
const MISSING_APP_DATA_MSG = "missing_app_data";
const MISSING_PROMPT_TEXT_MSG = "missing_prompt_text";

class Message extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playingAudio: false,
      showModal: false,
      similarModal: false,
      options: [],
      selectedChange: null,
      currentIntentLabel: null,
      modalTitle: "Edit Training Phrase",
      errorExplanation: null,
      similarityList: [],
      hideEmptyIntentWarning: true,
      hideDuplicateTrainingPhraseWarning: true,
      audioURL: null,
      isPartialsHidden: this.props.isPartialsHidden,
      copyTranscript: false,
      copyUnredactedAudio: false,
      segmentTooltipOpen: false,
      transcriptTooltipOpen: false,
      segmentUnavailable: false,
    };

    this.audio = React.createRef();
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.showSimilarPhrases = this.showSimilarPhrases.bind(this);
    this.audioControlClick = this.audioControlClick.bind(this); //audioControl click 2
    this.getMessageTextAndAudioRow = this.getMessageTextAndAudioRow.bind(this);
    this.getAgentColor = this.getAgentColor.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.addPhrase = this.addPhrase.bind(this);
    this.getTrainingBadge = this.getTrainingBadge.bind(this);
    this.getErrorExplanation = this.getErrorExplanation.bind(this);
    this.getStatusBadgeStyle = this.getStatusBadgeStyle.bind(this);
    this.hideSimilarities = this.hideSimilarities.bind(this);
    this.getDownloadButton = this.getDownloadButton.bind(this);
    this.getPlayButton = this.getPlayButton.bind(this);
    this.downloadRecording = this.downloadRecording.bind(this);
    this.getPrompt = this.getPrompt.bind(this);
    this.getMessageRecordingUrl = this.getMessageRecordingUrl.bind(this);
    this.setErrorExplanation = this.setErrorExplanation.bind(this);
    this.getUnredactedUrlButton = this.getUnredactedUrlButton.bind(this)
    this.getPartialsData = this.getPartialsData.bind(this)
    this.getNonRedacted = this.getNonRedacted.bind(this)
    this.getNonRedactedTranscript = this.getNonRedactedTranscript.bind(this)
    this.getUnredactedTranscriptButton = this.getUnredactedTranscriptButton.bind(this)
    this.toggleSegmentTooltip = this.toggleSegmentTooltip.bind(this);
    this.toggleTranscriptTooltip = this.toggleTranscriptTooltip.bind(this);
    this.partialsPermitted = this.partialsPermitted.bind(this);
    this.asrPermitted = this.asrPermitted.bind(this);
  }
  componentDidMount() {
    this.setErrorExplanation();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps !== this.props) {
      this.setState({
        isPartialsHidden: this.props.isPartialsHidden,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.getOptions();
    if (nextProps.existingPhrase && nextProps.existingPhrase.length === 0) {
      this.setState({
        modalTitle: "Add Training Phrase",
      });
    }
  }

  setErrorExplanation() {
    if (
      [MISSING_APP_DATA_MSG, MISSING_PROMPT_TEXT_MSG].includes(
        this.props.message.message
      )
    ) {
      this.setState({
        errorExplanation: "Please contact the app team to fix it.",
      });
    } else if (this.props.message.intentError) {
      this.setState({ errorExplanation: "NLU confidence is below threshold" });
    } else if (
      this.props.message.missedIntent &&
      !this.props.message.intentError &&
      this.props.message.type !== "username" &&
      this.props.message.type !== "password"
    ) {
      this.setState({
        errorExplanation: "NLU was unable to predict an intent for this input",
      });
    } else if (
      !this.props.message.message &&
      !this.props.message.errorMessage
    ) {
      this.setState({ errorExplanation: "Please contact support to resolve." });
    }
  }

  /**
   *
   * @returns {Promise<string>}
   */
  async getMessageRecordingUrl() {
    if (this.props.message && this.props.message.recordingId) {
      if (this.props.settings.audioStorage === "prism") {
        return apiCalls.getPrismMetadata(
            this.props.message.conversationId,
            this.props.message.recordingId
          )
          .then((res) => res.data.url.filter(val=>val._text.includes('https'))[0]?._text );
      } else {
        return Promise.resolve(`${apiCalls.getApiUrl()}/messages/recordings/${
          this.props.message.recordingId
        }/stream`);
      }
    }
  }

  getStatusBadgeStyle() {
    if (
      this.props.message.errorMessage === "No Input Detected" ||
      this.props.message.errorMessage === "No Input" ||
      (this.props.message.agent === "user" && !this.props.message.message)
    ) {
      return "intent-error.png";
    } else if (this.props.message.predictionError) {
      return "no-error.png";
    } else if (this.props.message.intentError) {
      return "intent-error.png";
    } else if (
      this.props.message.missedIntent &&
      !(
        this.props.message.messageType === "DTMF" ||
        this.props.message.messageType === "GRAMMAR"
      )
    ) {
      return "unknown-intent.png";
    } else if (this.props.message.formError) {
      if (this.state.errorExplanation === null) {
        this.setState({
          errorExplanation: "Input was rejected by the form validation rules",
        });
      }
      if (this.getInAuthentication(this.props.message.type)) {
        return "redact-error.png";
      } else {
        return "form-error.png";
      }
    } else {
      if (this.getInAuthentication(this.props.message.type)) {
        return "redact-success.png";
      } else {
        return "no-error.png";
      }
    }
  }

  getToolTipText() {
    if (
      this.props.message.errorMessage === "No Input Detected" ||
      this.props.message.errorMessage === "No Input" ||
      (this.props.message.agent === "user" && !this.props.message.message)
    ) {
      return "No Input";
    } else if (this.props.message.intentError) {
      return "Intent Warning";
    } else if (this.props.message.missedIntent && !(this.props.message.messageType === "DTMF" || this.props.message.messageType === "GRAMMAR")) {
      return "Unknown Intent";
    } else if (this.props.message.formError) {
      return "Form Warning";
    } else {
      return "Healthy";
    }
  }

  hideSimilarities() {
    this.setState({ similarModal: false });
  }

  getTrainingBadge() {
    if (
      this.props.message.agent === "user" &&
      this.props.message.type !== "quickReply" &&
      this.props.message.message.length > 0 &&
      ["admin", "designer"].includes(this.props.user.role)
    ) {
      if (this.props.existingPhrase && this.props.existingPhrase.length === 0) {
        return [
          !this.props.freeze && (
            this.props.message.messageType !== "DTMF" && this.props.message.messageType !== "GRAMMAR" &&
            this.props.versionName && !this.props.versionName.startsWith("*") &&
            <BadgeWithAuth
              key="0"
              action="create"
              pathname={this.props.location.pathname}
              color="primary"
              className="badge badge-success add-badge"
              onClick={this.showModal}
              text="Add"
            ></BadgeWithAuth>
          ),
          this.props.message.messageType !== "DTMF" && this.props.message.messageType !== "GRAMMAR" &&
          <Badge
            key="1"
            cursor="pointer"
            className="badge badge-success similarity-badge similarity-badge-pointer"
            onMouseEnter={this.showSimilarPhrases}
            onMouseLeave={this.hideSimilarities}
          >
            <i className="fa cui-speedometer similar-icon"></i>
          </Badge>,
          <div
            key="2"
            className="similarity-table"
            hidden={!this.state.similarModal}
            onMouseEnter={this.showSimilarPhrases}
            onMouseLeave={this.hideSimilarities}
          >
            <Table
              bordered
              hidden={!this.state.similarModal}
              className="similarity-table-margin"
            >
              <thead>
                <tr>
                  <th>Similar Training Phrase</th>
                  <th>Intent</th>
                  <th>Similarity</th>
                </tr>
              </thead>
              <tbody>
                {this.state.similarityList.map((phraseObj) => {
                  return (
                    <tr key={phraseObj.TrainingPhraseId}>
                      <th>{phraseObj.TrainingPhraseText}</th>
                      <td>{phraseObj.similarIntent}</td>
                      <td>{phraseObj.rating}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>,
        ];
      } else {
        return [
          <Badge className="saved-badge" key="0">
            <img alt="" src="no-error.png" className="saved-badge-img"></img>
            <span color="white">
              {" "}
              <font color="white">Exists in Training Set</font>
            </span>
          </Badge>,
          this.props.versionName && !this.props.versionName.startsWith("*") ? <BadgeWithAuth
            key="1"
            action="update"
            pathname={this.props.location.pathname}
            onClick={this.showModal}
            className="badge badge-success update-badge"
            text={[
              " ",
              <i key="0" className="fa fa-edit  "></i>,
              <span key="1" className="text-muted"></span>,
            ]}
          ></BadgeWithAuth> : null,
        ];
      }
    }
  }

  getMessageIntent() {
    let message = this.props.message;
    if (
      message &&
      message.message &&
      !message.handoffActive &&
      !["username", "password", "form", "file"].includes(message.type) &&
      message.agent === "user" &&
      !message.handoffActive &&
      message.messageType === "SPOKEN" &&
      (message.message !== null || message.message !== '') &&
      message.message !== "/disconnect"
    ) {
      let shouldDisplayASRConf = this.props.isVoice && message.asrConfidence && this.asrPermitted();
      let asrConfLabel = message.messageType && message.messageType.toLowerCase().includes("grammar") ? "Grammar" : "ASR";
      let isAllowedUser = this.props.user.role === 'admin' || this.props.user.role === 'designer' || this.props.user.role === 'analyst';
      if (message.intent) {
        return (
          <div>
            {shouldDisplayASRConf && (
              <Row className="messagesIntentRow">
                <Col className="messages-row">
                  {`${asrConfLabel} Confidence: ${this.formatPercentage(message.asrConfidence)}%, `}
                  {`${asrConfLabel} Threshold: ${this.formatPercentage(message.asrThreshold)}%, `}
                  {isAllowedUser && `${asrConfLabel} Engine: ${message.asr_engine === undefined ? '' : message.asr_engine}`}
                </Col>
              </Row>
            )}
            <Row className="messagesIntentRow">
              <Col className="messages-row">
                {`NLU Confidence: ${this.formatPercentage(message.nluConfidence)}%, `}
                {`NLU Threshold: ${this.formatPercentage(message.nluThreshold)}%, `}
                {`INTENT: ${message.intent}`}
                {this.getTrainingBadge()}
              </Col>
            </Row>
          </div>
        );
      }
      else {
        return (
          <div>
            {shouldDisplayASRConf && (
              <Row className="messagesIntentRow">
                <Col className="messages-row">
                  {`${asrConfLabel} Confidence: ${this.formatPercentage(message.asrConfidence)}%, `}
                  {`${asrConfLabel} Threshold: ${this.formatPercentage(message.asrThreshold)}%`}
                </Col>
              </Row>
            )}
            {!message.requestedSlot && (
              <Row className="messagesIntentRow">
                <Col className="messages-row">
                  {`NLU Confidence: ${this.formatPercentage(message.nluConfidence)}%, `}
                  {`NLU Threshold: ${this.formatPercentage(message.nluThreshold)}%, `}
                  {`Intent: `}
                  <span className="unknown-warning">Unknown</span>
                  <i className="fa fa-warning unknown-warning-text-color"></i>
                  {this.getTrainingBadge()}
                </Col>
              </Row>
            )}
          </div>
        );
      }
    }
  }

  getPrompt() {
    let message = this.props.message;
    if (message.handoffActive) {
      return;
    }
    if (message && message.agent === "bot") {
      if (message.promptName) {
        return (
          <Row className="botPromptRow">
            <Col className="messages-row bot-prompt-row-padding">
              PROMPT: {message.promptName}
            </Col>
          </Row>
        );
      }
    }
  }

  getErrorExplanation() {
    let isNoInput =
      this.props.message.errorMessage === "No Input Detected" ||
      this.props.message.errorMessage === "No Input";
    if (
      this.state.errorExplanation &&
      (this.props.message.message || !isNoInput)
    ) {
      return (
        <Row className="error-explanation-row">
          <Col className="error-explanation">
            *{this.state.errorExplanation}
          </Col>
        </Row>
      );
    }
  }

  formatPercentage(decVal) {
    return Number(decVal * 100).toFixed(2);
  }

  getAudioControlIcon() {
    if (this.state.playingAudio) {
      return "fa fa-stop fa-md mt-2";
    } else {
      return "fa fa-play fa-md mt-2";
    }
  }

  downloadRecording(e) {
    if(e) e.preventDefault();
    if (this.props.settings.audioStorage === "prism") {
      let startDate = moment.tz(parseInt(this.props.message.timestamp), this.props.settings.timezone).format("MM.DD.YY_hhmmss")
      let fileName = `${window.location.hostname}_${this.props.message.conversationId}_${startDate}.mp3`

      if(this.state.audioURL){
        apiCalls.downloadLink(
          this.state.audioURL,
          fileName
        );
      }
      else{
        this.getMessageRecordingUrl().then((prismURL)=>{
          apiCalls.downloadLink(
            prismURL,
            fileName
          )
        })
      }
    } else {
      apiCalls.downloadRecording(this.props.message.recordingId);
    }
  }

  getDownloadButton() {
    if (this.props.settings.downloadRecording && this.props.message.messageType !== "DTMF" && this.props.message?.recordingId) {
      return (
        <a onClick={this.downloadRecording} href="/#" className="download-button">
          <i  className="fa fa-download fa-md mt-2" />
        </a>
      );
    }
  }

  getPlayButton() {
    if (this.props.settings.recordingSegments && this.props.message?.recordingId) {
      return (
        <a onClick={this.audioControlClick} href="/#" className="play-button">
          <i className={this.getAudioControlIcon()} />
        </a>
      );
    }
  }

  getNonRedacted() {
    apiCalls.getPrismMetadataUnredacted(this.props.message.conversationId, this.props.message.recordingId).then((res) => {
      if (res.data) {
        navigator.clipboard.writeText(res.data.url._text)
        this.setState({
          copyUnredactedAudio: true
        }, () => {
          window.setTimeout(() => {
            this.setState({ copyUnredactedAudio: false })
          }, 1000);
        });
      }
      else {
        this.props.displayToast(`Unredacted audio not available`, "warn");
      }
    })
  }

  getNonRedactedTranscript()
  {
    apiCalls.getPrismTranscript(this.props.message.conversationId, this.props.message.recordingId).then((res)=>{
      if(res.data){
        navigator.clipboard.writeText(res.data.url._text)
        this.setState({
          copyTranscript: true
        }, () => {
          window.setTimeout(() => {
            this.setState({ copyTranscript: false })
          }, 1000);
        });
      }
      else{
        this.props.displayToast(`Unredacted transcript not available`, "warn");
      }
    })
  }

  getUnredactedUrlButton() {
    if (this.props.settings.recordingSegments && (this.props.user.role === "admin" || this.props.user.role === "designer") && this.props.message.messageType !== "GRAMMAR") {
      return null;
      // return (
        // FIX AIMED FOR RELEASE 3.16.0
        // <div className="prism-transcript">
        //   <Button
        //     id={"prismUnredactedAudioBtn" + this.props.message.messageId}
        //     className="prismTranscriptBtn prism-conversation-btn"
        //     onClick={this.getNonRedacted}
        //   >
        //     <img alt="" src="unredacted-audio.png" className="prism-unredacted-img prism-unredacted-display"></img>
        //   </Button>
        //   <Tooltip
        //     target={"prismUnredactedAudioBtn" + this.props.message.messageId}
        //     trigger="click"
        //     isOpen={this.state.copyUnredactedAudio}
        //   >
        //     Copied!
        //   </Tooltip>
        //   <Tooltip
        //     placement="bottom"
        //     isOpen={this.state.segmentTooltipOpen}
        //     target={"prismUnredactedAudioBtn" + this.props.message.messageId}
        //     toggle={this.toggleSegmentTooltip}
        //   >
        //     Copy unredacted audio URL
        //   </Tooltip>
        // </div>
      // );
    }
  }

  getUnredactedTranscriptButton() {
    if (this.props.settings.recordingSegments && (this.props.user.role === "admin" || this.props.user.role === "designer") && this.props.message.messageType !== "GRAMMAR") {
      return null;
      // return (
        // FIX AIMED FOR RELEASE 3.16.0
        // <div className="prism-transcript">
        //   <Button
        //     id={"prismTranscriptBtn" + this.props.message.messageId}
        //     className="prismTranscriptBtn prism-conversation-btn"
        //     onClick={this.getNonRedactedTranscript}
        //   >
        //     <img alt="" src="unredacted-transcript.png" className="prism-unredacted-img"></img>
        //   </Button>
        //   <Tooltip
        //     target={"prismTranscriptBtn" + this.props.message.messageId}
        //     trigger="click"
        //     isOpen={this.state.copyTranscript}
        //   >
        //     Copied!
        //   </Tooltip>
        //   <Tooltip
        //     placement="bottom"
        //     isOpen={this.state.transcriptTooltipOpen}
        //     target={"prismTranscriptBtn" + this.props.message.messageId}
        //     toggle={this.toggleTranscriptTooltip}
        //   >
        //     Copy unredacted transcript
        //   </Tooltip>
        // </div>
      // );
    }
  }

  getMessageTextAndAudioRow() {
    if (this.props.message.recordingId) {
      if (this.getInAuthentication(this.props.message.type)) {
        return [
          <Col xs="10" key="1">
            <Badge className="messageMetadataBadge">
              **REDACTED** - PII DATA
            </Badge>
          </Col>
        ];
      }
      else {
        return [
          <Col xs="8" key="1">
            {this.formatUserMsg(
              this.props.message.message,
              this.props.message.messageType,
              this.props.message.errorMessage
            )}

            <p
              className="messages-row no-margin-bottom"
              hidden={!this.state.segmentUnavailable}
            >Failed to retrieve audio segment, try again later</p>
          </Col>,
          <Col key="2">
            <div className="message-audio-btns">
              <div>{this.getUnredactedTranscriptButton()}</div>
              <div>{this.getUnredactedUrlButton()}</div>
              <div>{this.getDownloadButton()}</div>
              <div>{this.getPlayButton()}</div>
            </div>
          </Col>,
        ];
      }
    }
    else if (this.props.message.agent === "system") {
      const systemEventMessage = this.props.message.message.split("|");
      return (
        <Col xs="12">
          <Badge className="systemEvtsBadge">{systemEventMessage[0]}</Badge>
          {systemEventMessage[1]}
        </Col>
      );
    }
    else if (this.props.message.agent === "app") {
      if (this.props.message.message === MISSING_APP_DATA_MSG) {
        return (
          <Col xs="12">
            <Badge className="messageErrorMetadataBadge">
              {_.upperCase(this.props.message.message)}
            </Badge>
          </Col>
        );
      }
      else {
        return (
          <Col xs="12">
            <Badge className="systemEvtsBadge">{_.upperCase(this.props.message.message)}</Badge>
          </Col>
        );
      }
    }
    else {
      if (this.props.message.agent === "user") {
        if (this.props.message.type === "form") {
          return this.displayFormResponse(this.props.message.message);
        }
        else if (this.props.message.type === "quickReply") {
          return this.displayButtonResponse(this.props.message.message);
        }
        else if (this.props.message.type === "file") {
          return this.displayFileResponse(this.props.message.message);
        }
        else {
          if (this.getInAuthentication(this.props.message.type) || this.isWebchatPII()) {
            return (
              <Col xs="12">
                <Badge className="messageMetadataBadge">
                  **REDACTED** - PII DATA
                </Badge>
              </Col>
            );
          }
          else {
            return (
              <Col xs="12">
                {this.formatUserMsg(
                  this.props.message.message,
                  this.props.message.messageType,
                  this.props.message.errorMessage
                )}
              </Col>
            );
          }
        }
      }
      else {
        if (this.props.message.message === MISSING_PROMPT_TEXT_MSG) {
          return (
            <Col>
              <Badge className="messageErrorMetadataBadge">
                {_.upperCase(this.props.message.message)}
              </Badge>
            </Col>
          );
        }
        else {
          return <Col xs="12">{this.props.isSpanishLanguage ? this.props.message.spanish_message : this.props.message.message}</Col>;
        }
      }
    }
  }

  formatUserMsg(msg, messageType, errorMsg) {
    let badgeText, messageText;
    if (errorMsg || !msg) {
      errorMsg = errorMsg || "Unknown Error" // Falsy (undefined, null, or empty) user messages with no error messages.
      badgeText = errorMsg.startsWith("No Input") ? "No Input" : errorMsg
      return <Badge className="messageWarningErrorMetadataBadge">{badgeText}</Badge>
    }
    if (!this.props.isPartialsHidden && this.props.message.regex_original) {
      messageText = <div><strike>{this.props.message.regex_original}</strike> {msg}</div>
    } else {
      messageText = msg
    }
    if (messageType === "GRAMMAR") {
      return (<Badge style={{ backgroundColor: "#6CA0DC", color: "white", fontSize: "85%" }}>{messageText}</Badge>);
    } else {
      return messageText;
    }
  }

  handleAudio = (audioURL) =>{

    let audioObj = new Audio(audioURL);

    audioObj.play();

    audioObj.onerror = () =>{
      this.setState({
        segmentUnavailable: true,
        playingAudio: false
      })
    }

    audioObj.onended = () =>{ this.audioControlClick()}
    this.setState({
      audio: audioObj,
      playingAudio: true
    });

  }

  async audioControlClick(e) {
    if (e) e.preventDefault()
    if (this.state.playingAudio) {
      this.state.audio.pause();
      this.state.audio.currentTime = 0;
      this.setState({ playingAudio: false, });
    } else {
      if (!this.state.audioURL) {
        this.getMessageRecordingUrl()
          .then((prismURL) => {
            let audioObj = new Audio(`${apiCalls.getApiUrl()}/prism/stream?url=${prismURL}`);
            audioObj.onerror = (e) => {
              this.setState({
                segmentUnavailable: true,
                playingAudio: false,
              });
            };

            audioObj.play();
            audioObj.onended = () => {
              this.audioControlClick();
            };
            this.setState({
              audio: audioObj,
              playingAudio: true,
            });
          })
          .catch(() => {
            this.setState({ segmentUnavailable: true });
          });
      } else {
        this.state.audio.play();
        this.setState({
          playingAudio: true,
        });
      }
    }
  }

  getAgentColor(agent) {
    if (agent === "bot") {
      return "secondary";
    } else if (["system", "app"].includes(agent)) {
      return "success";
    } else if (agent === "liveAgent") {
      return "info";
    } else {
      return null;
    }
  }

  showModal() {
    this.setState({
      showModal: true,
      hideEmptyIntentWarning: true,
      hideDuplicateTrainingPhraseWarning: true,
    });
  }

  hideModal() {
    this.setState({
      selectedChange: null,
      showModal: false,
    });
  }

  toggleSegmentTooltip() {
    this.setState({
      segmentTooltipOpen: !this.state.segmentTooltipOpen
    });
  }

  toggleTranscriptTooltip() {
    this.setState({
      transcriptTooltipOpen: !this.state.transcriptTooltipOpen
    });
  }

  showSimilarPhrases() {
    if (this.props.trainingPhraseData.length > 0) {
      let phraseList = this.props.trainingPhraseData.map((phraseObj) => {
        return phraseObj.TrainingPhraseText;
      });

      let bestMatchList = stringSimilarity
        .findBestMatch(this.props.message.message, phraseList)
        .ratings.sort((a, b) => (a.rating < b.rating ? 1 : -1))
        .slice(0, 4);

      let matchingPhraseList = [];

      this.props.trainingPhraseData.forEach((trainingObj) => {
        let f = bestMatchList.filter(
          (similarObj) => similarObj.target === trainingObj.TrainingPhraseText
        );
        if (f.length > 0) {
          let matchingPhraseObj = trainingObj;
          if (
            this.props.intentData.filter(
              (val) => val.IntentId === matchingPhraseObj.IntentId
            ).length > 0
          ) {
            matchingPhraseObj.similarIntent = this.props.intentData.filter(
              (val) => val.IntentId === matchingPhraseObj.IntentId
            )[0].IntentName;
            matchingPhraseObj.rating = Math.round(f[0].rating * 100);
            matchingPhraseList.push(matchingPhraseObj);
          }
        }
      });

      this.setState({
        similarityList: matchingPhraseList.sort((a, b) =>
          a.rating < b.rating ? 1 : -1
        ),
        similarModal: true,
      });
    }
  }

  handleInputChange(value, e) {
    if (e.action === "select-option") {
      //want to add
      this.setState({
        selectedChange: { label: value.label, value: value.value },
      });
    } else if (e.action === "clear") {
      this.setState({ selectedChange: null });
    } else if (e.action === "create-option") {
      //   this.createNewtag(value[value.length - 1].value);
      //   this.addTagToConversation(value[value.length - 1].value);
      //(REFRESH)
      this.setState({ selectedChange: value.value });
    } else if (e.action === "remove-value") {
      this.setState({ selectedChange: null });
    }
  }

  getOptions() {
    let currentIntentLabel = null;
    if (this.props.intentData) {
      let optionsList = this.props.intentData.map((val) => {
        //fill options for dropdown
        if (val.IntentName === this.props.message.intent) {
          //add default current label
          currentIntentLabel = { value: val.IntentId, label: val.IntentName }; //set current selected label from dropdown to the prediced intent
        }
        return { value: val.IntentId, label: val.IntentName };
      });
      this.setState({
        options: optionsList,
        selectedChange: currentIntentLabel,
      });
    }

    //If phrase already exists, set default label to it's corresponding saved intent for the options dropdown
    if (this.props.existingPhrase && this.props.existingPhrase.length > 0) {
      let defaultLabel = this.state.options.filter(
        (intentLabel) =>
          intentLabel.value === this.props.existingPhrase[0].IntentId
      )[0];
      this.setState({ selectedChange: defaultLabel });
    }
  }

  addPhrase() {
    let intentId, message;
    if (
      this.state.selectedChange &&
      this.state.selectedChange.label.trim().length > 0
    )
      intentId = this.props.intentData.filter(
        (intent) => intent.IntentName === this.state.selectedChange.label
      )[0].IntentId;
    if (this.props.message.message)
      message = this.props.message.message
        .replace(/[[\]']+/g, "")
        .replace(/ *\([^)]*\) */g, " ");
    if (intentId) {
      let isDuplicateTrainingPhrase = this.props.trainingPhraseData.find(
        (trainingPhrase) =>
          trainingPhrase.TrainingPhraseText.toLowerCase() ===
            message.toLowerCase()
      );
      if (!isDuplicateTrainingPhrase) {
        apiCalls.addPhrase(intentId, message).then((res) => {
          this.setState({
            hideEmptyIntentWarning: true,
            hideDuplicateTrainingPhraseWarning: true,
          });
          if (res) {
            if (res.rowsAffected.length > 0) {
              this.props.displayToast("Training data modified Successfully", "success");
            }
            this.props.refresh();
          } else {
            this.props.handleAPIError(res);
          }
        });
        this.setState({
          selectedChange: null,
          showModal: false,
        });
        this.props.refresh();
      } else {
        this.setState({ hideDuplicateTrainingPhraseWarning: false });
      }
    } else {
      this.setState({ hideEmptyIntentWarning: false });
    }
  }

  getMetadata() {
    if (this.props.message.handoffActive) {
      return;
    }
    let message = this.props.message;
    if (
      message.message &&
      message.agent === "user" &&
      (message.requestedSlot || message.activeForm || message.messageType)
    ) {
      return (
        <Row>
          <Col>
            {this.getRequestedSlot(message.requestedSlot)}
            {this.getActiveForm(message.activeForm)}
            {this.formatMessageType(message.messageType, message.inputType)}
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  }

  partialsPermitted(){
      return validate(this.props?.user?.role, ['admin', 'designer'] )
  }

  asrPermitted(){
    return validate(this.props?.user?.role, ['admin', 'designer', 'analyst'])
  }

  getPartialsData() {
    if (
      this.partialsPermitted() &&
      this.props.message.agent === "user" &&
      this.props.message.partials !== undefined &&
      this.props.message.partials !== null
    ) {
      let partialsArr = JSON.parse(this.props.message.partials).reverse().slice(0, 5);
      if (
        !this.state.isPartialsHidden &&
        this.props.message.messageType === "SPOKEN" &&
        (this.props.user.role === "admin" ||
          this.props.user.role === "designer")
      ) {
        return (
          <div>
            <Col className="partials-col">
              <Row className="partials-padding bold-font-weight">Partials:</Row>
              <Row className="partials-padding">{JSON.stringify(partialsArr)}</Row>
            </Col>
          </div>
        );
      }
      else {
        return null;
      }
    } else
      return null;
  }
  /*
    This function is in place because of the fact that for a brief period of time
    conversation writer would write the partials array into the database with an
    inconsistent quote pattern. This made the json parser mad.
   */
  partialsWorkaround() {
    if (this.props.message.partials && this.props.message.message) {
      console.log("entering workaround")
      const partialsArr = this.props.message.partials.split(",")
      console.log("partials arr: " + partialsArr)
      for (let i = partialsArr.length; i > 0; i--) {
        if (partialsArr[i] === this.props.message.message) {
          console.log("i = " + i + ": " + partialsArr[i] + " =? " + this.props.message.message)
          return "partials:" + (partialsArr.length - i);
        }
      }
    }
    return "unknown"
  }

  getMatchSource() {
    if (this.props.message.partials !== null) {
      let matchSource = "unknown"
      if (this.props.message.message === this.props.message.original_text) {
        matchSource = "original";
      }
      if (matchSource === "unknown") {
        try {
          let partialsArr = JSON.parse(this.props.message.partials)
          partialsArr = partialsArr.reverse();
          for (let i = 0; i < partialsArr.length; i++) {
            if (partialsArr[i] === this.props.message.message) {
              matchSource = "partial:" + (i + 1);
            }
          }
        } catch (e) {
          matchSource = this.partialsWorkaround()
        }
      }
      if (
        !this.state.isPartialsHidden &&
        this.props.message.messageType === "SPOKEN" &&
        (this.props.user.role === "admin" ||
          this.props.user.role === "designer")
      ) {
        return (
          <Button size="sm" className="messageMetadataBtn" disabled>
            <Badge className="messageInputMetadataBadge">
              Message Source: {matchSource.toUpperCase()}
            </Badge>
          </Button>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getRequestedSlot(requestedSlot) {
    if (requestedSlot) {
      return (
        <Button color="light" size="sm" className="messageMetadataBtn" disabled>
          <Badge className="messageMetadataBadge">Slot: {requestedSlot}</Badge>
        </Button>
      );
    }
  }

  getActiveForm(formName) {
    if (formName) {
      return (
        <Button color="light" size="sm" className="messageMetadataBtn" disabled>
          <Badge className="messageMetadataBadge">Form: {formName}</Badge>
        </Button>
      );
    }
  }

  getMessageType(messageType, inputType) {
    switch (messageType) {
      case "GRAMMAR":
        if (inputType === "SPEECH") inputType = "SPOKEN";
        return `${inputType}_${messageType}`;
      case "SPOKEN":
        return `SPOKEN_NLU`;
      case "DTMF":
        return `DTMF_NLU`;
      default:
        return "NA";
    }
  }

  formatMessageType(messageType, inputType) {
    return (
      <Button size="sm" className="messageMetadataBtn" disabled>
        <Badge className="messageInputMetadataBadge">
          Input Mode: {this.getMessageType(messageType, inputType)}
        </Badge>
      </Button>
    );
  }

  getInAuthentication(type) {
    return type === "username" || type === "password";
  }

  // Hide webchat credit card information from user
  isWebchatPII() {
    return this.props.channelName === "OMNI_WEBCHAT_00001" && this.props.message.activeForm === "action_credit_card_collector" && this.props.message.intent === 'out-of-scope';
  }

  displayFormResponse(userResponse) {
    let payload = JSON.parse(userResponse);

    return (
      <Col xs="4">
        <Form>
          {Object.keys(payload).map((key, idx) => (
            <FormGroup className="formGroupCardResponse" row>
              <InputGroup size="sm">
                <InputGroupAddon
                  className="messageFormInputAddon"
                  addonType="prepend"
                >
                  <InputGroupText className="messageFormInputSpan">
                    {_.startCase(key)}
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={payload[key]}
                  className="messageFormInputVal"
                  disabled
                />
              </InputGroup>
            </FormGroup>
          ))}
        </Form>
      </Col>
    );
  }

  displayButtonResponse(quickReplyVal) {
    if (quickReplyVal && quickReplyVal.startsWith("/")) {
      quickReplyVal = quickReplyVal.slice(1);
    }

    return (
      <Col xs="6">
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <img alt="" src="clicker.png" className="clicker-img"></img>
            </InputGroupText>
          </InputGroupAddon>
          <Input
            className="clicker-input"
            value={quickReplyVal}
            disabled
          />
        </InputGroup>
      </Col>
    );
  }

  displayFileResponse(fileResponse) {
    return (
      <Col xs="4">
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <span className="icon-cloud-upload"></span>
            </InputGroupText>
          </InputGroupAddon>
          <Input
            className="transparent-background"
            value={fileResponse}
            disabled
          />
        </InputGroup>
      </Col>
    );
  }

  displayAgentText(agent) {
    if (agent === "User") {
      return "Customer";
    }

    return agent;
  }

  render() {
    let messageNumber = this.props.message.agent === "user" || this.props.message.agent === "bot" ? this.props.messageNumber + ". " : "";
    if (this.props.message.message !== null) {
      let agent = this.props.message.agent;
      agent = agent.charAt(0).toUpperCase() + agent.slice(1);
      return (
        <div>
          <ListGroupItem
            className="inherit-position"
            key={this.props.keyx}
            color={this.getAgentColor(this.props.message.agent)}
          >
            <Modal
              isOpen={this.state.showModal}
              id="trainingDataModal"
              className={this.props.className}
            >
              <ModalHeader>{this.state.modalTitle}</ModalHeader>
              <ModalBody>
                <Row className="training-data-model-margin">
                  <Col xs="2" className="training-data-model-col-padding">Version:</Col>
                  <Col>
                    <Input
                      type="text"
                      disabled
                      defaultValue={this.props.versionName}
                    />
                  </Col>
                </Row>
                <Row className="training-data-model-margin">
                  <Col xs="2" className="training-data-model-col-padding">Phrase:</Col>
                  <Col>
                    <Input
                      type="text"
                      disabled
                      defaultValue={this.props.message.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="2" className="training-data-model-col-extra-padding">Intent:</Col>
                  <Col xs="10">
                    <CreatableSelect
                      isClearable
                      onChange={this.handleInputChange}
                      onInputChange={this.handleInputChange}
                      defaultValue={this.state.selectedChange}
                      options={this.state.options}
                    />
                    <p
                      hidden={this.state.hideDuplicateTrainingPhraseWarning}
                      className="warnings-color"
                    >
                      {"Training phrase already exists in " + this.props.versionName + "."}
                    </p>
                    <p
                      hidden={this.state.hideEmptyIntentWarning}
                      className="warningsColor"
                    >
                      An intent must be selected.
                    </p>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="success"
                  size="sm"
                  color="success"
                  onClick={this.addPhrase}
                >
                  Update
                </Button>
                <Button color="danger" size="sm" onClick={this.hideModal}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            <Row className="status-badge-color">
              <Col xs="1">
                {/*<Badge style={this.getStatusBadgeStyle()}>..</Badge>*/}
                <img
                  alt=""
                  src={this.getStatusBadgeStyle()}
                  title={this.getToolTipText()}
                  className="status-badge"
                ></img>
              </Col>
              <Col xs="11">
                <Row>
                  <Col xs="8" className="bold-font-weight">
                    {this.props.formatCount(messageNumber)}
                    {this.displayAgentText(agent)}
                  </Col>
                  <Col xs="4" className="timestamp-text-align">
                    {moment
                      .tz(
                        parseInt(this.props.message.timestamp),
                        this.props.settings.timezone
                      )
                      .format("h:mm:ss A")}
                  </Col>
                </Row>
                <Row>{this.getMessageTextAndAudioRow()}</Row>
                {this.getMetadata()}
                {this.getPartialsData()}
                {this.getMatchSource()}
                {this.getPrompt()}
                {this.getMessageIntent()}
                {this.props.message.messageType !== "GRAMMAR" &&
                  this.props.message.messageType !== "DTMF" &&
                  this.getErrorExplanation()}
                {this.props.message.messageType !== "GRAMMAR" &&
                  this.props.message.messageType !== "DTMF" && (
                    <Entities entities={this.props.message.entities} />
                  )}
              </Col>
            </Row>
          </ListGroupItem>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Message;
